<template>
    <div>
        <loading :active.sync="loadingApp" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <Toast :show.sync="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position" :icon="toast.icon"></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Referral</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div class="section detail-transaction-section pt-2" style="--height:200px;">
                <div class="detail-card text-center">
                    <!-- <ion-icon name="people" style="font-size: 64px;color:#0B8BCC;"></ion-icon> -->
                    <img :src="require('@/assets/referral.png')" alt="image" class="image mb-2 mt-1" style="height:100px;">
                    <h3>Referral</h3>
                    <p style="font-size:13px;line-height:20px;">Referral merupakan program yang bisa kamu gunakan untuk menambah komisi kamu hingga jutaan rupiah setiap bulannya. Ajak teman, keluarga atau orang lain untuk bergabung di <b>{{ VUE_ENV.VUE_APP_NAME }}</b> menggunakan kode referral kamu dan dapatkan komisinya.</p>
                    <blockquote class="blockquote element-copy">
                        <dd class="mb-1">Kode Referral</dd>
                        <h2 class="this-copy">{{ customer.affiliate_id }}</h2>
                        <a class="text-primary" @click="copy">Salin Kode</a>
                    </blockquote>
                    <!-- <blockquote class="blockquote element-copy">
                        <dd class="mb-1">Link Referral</dd>
                        <h3 class="this-copy">http://qiosfin.link?reff={{customer.affiliate_id}}</h3>
                        <a class="text-primary" @click="copy">Salin Link</a>
                    </blockquote> -->
                    <button class="btn btn-primary btn-block" @click="actionSheet('show')"><ion-icon name="create"></ion-icon> Ubah Kode Referral</button>
                    
                    <!-- <div class="row mt-2">
                        <div class="col-6">
                            <router-link :to="{name:'referral.downline'}" class="btn btn-outline-primary btn-lg btn-block">
                                List Downline
                            </router-link>
                        </div>
                        <div class="col-6">
                            <router-link :to="{name:'referral.komisi'}" class="btn btn-outline-primary btn-lg btn-block">
                                List Komisi
                            </router-link>
                        </div>
                    </div> -->
                    
                </div>
            </div>
            <!-- <div class="section full mt-2">
                <div class="listview-title pl-3 pr-3">Bonus/Komisi yang kamu terima senilai</div>
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item">
                            <img :src="require('@/assets/member.png')" alt="image" class="image">
                            <div class="in">
                                <b>Qios Member</b>
                                <span class="text-primary text-right"><b>Rp {{ setting.komisi_transaction_referral_basic | rupiah }} / Trx DL</b></span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item">
                            <img :src="require('@/assets/premium.png')" alt="image" class="image">
                            <div class="in">
                                <b>Qios Premium</b>
                                <span class="text-primary text-right"><b>Rp {{ setting.komisi_transaction_referral_premium | rupiah }} / Trx DL</b></span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item">
                            <img :src="require('@/assets/bisnis.png')" alt="image" class="image">
                            <div class="in">
                                <b>Qios Bisnis</b>
                                <span class="text-primary text-right"><b>Rp {{ setting.komisi_transaction_referral_premium | rupiah }} / Trx DL</b></span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item">
                            <img :src="require('@/assets/MD.png')" alt="image" class="image">
                            <div class="in">
                                <b>Master Dealer</b>
                                <span class="text-primary text-right"><b>Selisih Harga / Trx DL</b></span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div> -->
            <div class="section inset mt-2 mb-2">
                <div class="accordion" id="tutorial">
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#tutorial0'">
                                <b>Apa itu Downline dan Upline?</b>
                            </button>
                        </div>
                        <div :id="'tutorial0'" class="accordion-body collapse" data-parent="#tutorial">
                            <div class="accordion-content">
                                <ul>
                                    <li>Downline (DL) adalah orang yang kamu ajak bergabung di {{VUE_ENV.VUE_APP_NAME}} dengan menggunakan kode referral kamu</li>
                                    <li>Upline (UL) adalah orang yang mengajak orang lain bergabung di {{VUE_ENV.VUE_APP_NAME}} dengan menggunakan kode referral (Kamu)</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#tutorial1'">
                                <b>Cara Mencari Downline dengan Kode</b>
                            </button>
                        </div>
                        <div :id="'tutorial1'" class="accordion-body collapse" data-parent="#tutorial">
                            <div class="accordion-content">
                                <ol>
                                    <li>Ajak teman, keluarga atau orang lain mendownload aplikasi {{VUE_ENV.VUE_APP_NAME}} di playstore</li>
                                    <li>Saat Calon Downline kamu melakukan pendaftaran, pada kolom kode referral silahkan di isi dengan kode referral kamu, yaitu : <b>{{customer.affiliate_id}}</b></li>
                                    <li>Setelah berhasil terdaftar, kamu dapat mengecek apakah orang yang kamu ajak tadi sudah menjadi downline kamu atau tidak di menu referral</li>
                                    <li>Jika sudah terdaftar sebagai downline kamu, maka kamu akan mendapatkan komisi setiap downline kamu melakukan transkasi pada produk apapun</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#tutorial2'">
                                <b>Cara Mencari Downline dengan Link</b>
                            </button>
                        </div>
                        <div :id="'tutorial2'" class="accordion-body collapse" data-parent="#tutorial">
                            <div class="accordion-content">
                                <ol>
                                    <li>Sebarkan link referral kamu ke sosial media atau dimanapun dengan ajakan untuk mendaftar di {{VUE_ENV.VUE_APP_NAME}} menggunakan link referral kamu, yaitu : <a :href="'http://qiosfin.link?reff='+customer.affiliate_id"><b>http://qiosfin.link?reff={{customer.affiliate_id}}</b></a></li>
                                    <li>Setelah berhasil terdaftar, kamu dapat mengecek apakah orang mendaftar tadi sudah menjadi downline kamu atau tidak di menu referral</li>
                                    <li>Jika sudah terdaftar sebagai downline kamu, maka kamu akan mendapatkan komisi setiap downline kamu melakukan transkasi pada produk apapun</li>
                                </ol>
                            </div>
                        </div>
                    </div> -->
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#tutorial3'">
                                <b>Cara Mencari Downline di Playstore</b>
                            </button>
                        </div>
                        <div :id="'tutorial3'" class="accordion-body collapse" data-parent="#tutorial">
                            <div class="accordion-content">
                                <ol>
                                    <li>Beri rating dan review menarik aplikasi {{VUE_ENV.VUE_APP_NAME}} di playstore agar review kamu muncul paling atas.</li>
                                    <li>Pada review yang kamu tuliskan, silahkan sisipkan kode referral kamu : <b>{{customer.affiliate_id}}</b>, contohnya : <i>Aplikasi {{VUE_ENV.VUE_APP_NAME}} paling mantap, harga murah dan produk lengkap, ayo daftar sekarang menggunakan kode referral : <b>{{customer.affiliate_id}}</b></i></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#tutorial4'">
                                <b>Ilustrasi Perhitungan Bonus Transaksi</b>
                            </button>
                        </div>
                        <div :id="'tutorial4'" class="accordion-body collapse" data-parent="#tutorial">
                            <div class="accordion-content">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <tr>
                                            <th>Downline</th>
                                            <th>Komisi</th>
                                            <th>Transkasi</th>
                                            <th>Bonus/Hari</th>
                                            <th>Bonus/Bulan</th>
                                        </tr>
                                        <tr>
                                            <td class="text-nowrap">1</td>
                                            <td class="text-nowrap">Rp {{ komisi | rupiah }},-</td>
                                            <td class="text-nowrap">60 Trx/Hari</td>
                                            <td class="text-nowrap">Rp {{ 1 * komisi * 60 | rupiah }},-</td>
                                            <td class="text-nowrap">Rp {{ 1 * komisi * 60 * 30 | rupiah }},-</td>
                                        </tr>
                                        <tr>
                                            <td class="text-nowrap">10</td>
                                            <td class="text-nowrap">Rp {{ komisi | rupiah }},-</td>
                                            <td class="text-nowrap">60 Trx/Hari</td>
                                            <td class="text-nowrap">Rp {{ 10 * komisi * 60 | rupiah }},-</td>
                                            <td class="text-nowrap">Rp {{ 10 * komisi * 60 * 30 | rupiah }},-</td>
                                        </tr>
                                        <tr>
                                            <td class="text-nowrap">100</td>
                                            <td class="text-nowrap">Rp {{ komisi | rupiah }},-</td>
                                            <td class="text-nowrap">60 Trx/Hari</td>
                                            <td class="text-nowrap">Rp {{ 100 * komisi * 60 | rupiah }},-</td>
                                            <td class="text-nowrap">Rp {{ 100 * komisi * 60 * 30 | rupiah }},-</td>
                                        </tr>
                                        <tr>
                                            <td class="text-nowrap">1.000</td>
                                            <td class="text-nowrap">Rp {{ komisi | rupiah }},-</td>
                                            <td class="text-nowrap">60 Trx/Hari</td>
                                            <td class="text-nowrap">Rp {{ 1000 * komisi * 60 | rupiah }},-</td>
                                            <td class="text-nowrap">Rp {{ 1000 * komisi * 60 * 30 | rupiah }},-</td>
                                        </tr>
                                        <tr>
                                            <td class="text-nowrap">10.000</td>
                                            <td class="text-nowrap">Rp {{ komisi | rupiah }},-</td>
                                            <td class="text-nowrap">60 Trx/Hari</td>
                                            <td class="text-nowrap">Rp {{ 10000 * komisi * 60 | rupiah }},-</td>
                                            <td class="text-nowrap">Rp {{ 10000 * komisi * 60 * 30 | rupiah }},-</td>
                                        </tr>
                                    </table>
                                </div>
                                <p>Catatan : Geser table kesebelah kiri untuk melihat seluruh data ilustrasi</p>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="accordion-header">
                            <button class="btn collapsed text-left" type="button" data-toggle="collapse" :data-target="'#tutorial6'">
                                <b>Syarat & Ketentuan</b>
                            </button>
                        </div>
                        <div :id="'tutorial6'" class="accordion-body collapse" data-parent="#tutorial">
                            <div class="accordion-content">
                                <ol>
                                    <li>Downline yang kamu ajak akan menjadi downline kamu selamanya tanpa batas waktu, selama downline tersebut masih aktif bertransaksi kamu tetap akan mendapatkan komisi</li>
                                    <li>Bonus dari setiap transkasi downline kamu akan kamu terima berupa komisi yang dapat di tarik</li>
                                    <li>Komisi yang didapatkan dapat di tarik kembali menjadi saldo akun kamu</li>
                                    <li>Fitur Referral hanya berlaku satu tingkat, jika downline kamu mengajak orang lain lagi, maka itu adalah komisi untuk downline kamu</li>
                                    <li>Komisi yang kamu terima adalah bonus langsung dari {{VUE_ENV.VUE_APP_NAME}} dan tidak dibebankan ke downline kamu</li>
                                    <li>Harga kamu dan harga downline kamu sama rata atau tidak ada perbedaan karena tidak menggunakan sistem markup</li>
                                    <li>Syarat & Ketentuan lainnya mengikuti Syarat & Ketentuan utama</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <action-sheet ref="edit_kode_referral" :title="'Ubah Kode Referral'" :inset="true">
            <div class="form-group basic">
                <label class="label">Set Kode Referral</label>
                <input type="text" class="form-control form-control-sm text-uppercase" v-model="affiliate_id" oninput="this.value = this.value.replace(/[^a-z0-9]/gi, '')">
                <small><i>Min. 3 digit dan Maks. 15 digit</i></small>
            </div>
            <div class="form-group basic">
                <div class="row">
                    <div class="col-6">
                        <button class="btn btn-secondary btn-block" @click="actionSheet('hide')"> Batal</button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader :loading="loadingButton" :styled="'btn btn-primary btn-block'" @click.native="updateKodeReferral()">Simpan</ButtonLoader>
                    </div>
                </div>
            </div>
        </action-sheet>
    </div>
</template>
<script>
import $axios from './../../api.js'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            affiliate_id: '',
            loadingApp: true,
            loadingButton: false,
            komisi: 0
        }
    },
    computed: {
        ...mapState(['toast','VUE_ENV', 'customer', 'setting'])
    },
    methods:{
        ...mapActions(['getCustomer','getSetting']),
        copy: function (e) {
            this.$store.commit('SET_TOAST', {show:false})
            let text = window.$(e.target).parents('.element-copy').find('.this-copy')[0].innerText;
            let element = document.createElement("textarea");
            document.body.appendChild(element);
            element.value = text;
            element.select();
            document.execCommand("copy");
            document.body.removeChild(element);
            this.$store.commit('SET_TOAST', {show:true,message:'Berhasil disalin',tipe:'default', icon:'success'})
        },
        actionSheet(value){
            if(value == 'show'){
                if(this.customer.account_detail != null && this.customer.account_verified_status == 'APPROVED'){
                    let element = this.$refs.edit_kode_referral.$el
                    window.$(element).modal(value)
                }else{
                    this.$store.commit('SET_TOAST', {show:true,message:'Fitur ini hanya bisa digunakan oleh mitra yang telah melakukan verifikasi data diri.',tipe:'default',icon:'warning'})
                }
            }else{
                let element = this.$refs.edit_kode_referral.$el
                window.$(element).modal(value)
                this.affiliate_id = ''
            }
            
        },
        updateKodeReferral(){
            this.loadingButton = true
            $axios.post('/referral/update-kode-referral', {
                affiliate_id: this.affiliate_id
            }).then(() => {
                this.getCustomer()
                this.loadingButton = false
                this.actionSheet('hide')
                this.$store.commit('SET_TOAST', {show:true,message:'Berhasil',tipe:'default',icon:'success'})
            }).catch((error) => {
                console.log(error)
                this.actionSheet('hide')
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                this.loadingButton = false
                
            })
        }
    },
    mounted(){
        this.getSetting().then(() => {
            if(this.customer.role == 'Member'){
                this.komisi = this.setting.komisi_transaction_referral_basic
            }else if(this.customer.role == 'Premium'){
                this.komisi = this.setting.komisi_transaction_referral_premium
            }else if(this.customer.role == 'Bisnis'){
                this.komisi = this.setting.komisi_transaction_referral_premium
            }else if(this.customer.role == 'H2H'){
                this.komisi = 0
            }else if(this.customer.role == 'MD'){
                this.komisi = 100
            }
            this.loadingApp = false
        }).catch(() => {
            this.loadingApp = false
        })
    },
    destroyed(){
        this.$store.commit('RESET_TOAST')
    }
}
</script>